import React from 'react'
import Header from "../../components/header/index";
import Footer from "../../components/footer";
import FaqContent from './faqcontent/faqContent';

const faq = () => {
  return (
    <div className="main">
    <Header />
    <FaqContent />
    <Footer />
    </div>
  )
}

export default faq